export enum ReturnDisbursementStatus {
  Pending = "pending",
  InFlight = "in_flight",
  Paid = "paid",
  Failed = "failed",
  Canceled = "canceled",
}
